/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The notification types a Portal (customer) user can receive, exported to the frontend by TypeGen.
 */
export class NotificationPortalTypeKeys {
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.RequisitionStatusChanged}
     */
    static readonly requisition_status_changed: string = 'requisition_status_changed';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.InvoiceReceived}
     */
    static readonly invoice_received: string = 'invoice_received';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.ArchiveReady}
     */
    static readonly archive_ready: string = 'archive_ready';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.ArchiveFailed}
     */
    static readonly archive_failed: string = 'archive_failed';
}
